"use client";

import React, { useEffect, useState } from "react";
import { getCookieConsentValue } from "react-cookie-consent";
import CookieConsentNoticeInner from "./cookieConsentInner";
import useCookieConsent from "@/hooks/utils/useCookieConsent";

const CookieConsentNotice = () => {
  const { cookieConsent, handleAcceptConsent } = useCookieConsent();

  if (cookieConsent) return null;

  return <CookieConsentNoticeInner handleAcceptConsent={handleAcceptConsent} />;
};

export default CookieConsentNotice;
